var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1875 2.0625V9.0625C1.1875 9.29456 1.27969 9.51712 1.44378 9.68122C1.60788 9.84531 1.83044 9.9375 2.0625 9.9375H10.8125C10.9285 9.9375 11.0398 9.89141 11.1219 9.80936C11.2039 9.72731 11.25 9.61603 11.25 9.5V3.375C11.25 3.25897 11.2039 3.14769 11.1219 3.06564C11.0398 2.98359 10.9285 2.9375 10.8125 2.9375H2.0625C1.83044 2.9375 1.60788 2.84531 1.44378 2.68122C1.27969 2.51712 1.1875 2.29456 1.1875 2.0625ZM1.1875 2.0625C1.1875 1.83044 1.27969 1.60788 1.44378 1.44378C1.60788 1.27969 1.83044 1.1875 2.0625 1.1875H9.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5);
export default __webpack_public_path__ + "static/media/Vector (5).564c86a83af9b8e8b6c82871b62e3970.svg";
export { ForwardRef as ReactComponent };